import { GameRandom, Inject, Singleton } from '@denishussar/html5-game-engine';
import { ModelEvents } from '@denishussar/html5-game-engine/dist';
import { BussinesTripMarkerModel } from './BussinesTripMarkerModel';

export enum BussinesTripCity {
    Kaliningrad = 'Kaliningrad',
    SPetersburg = 'SPetersburg',
    Moscow = 'Moscow',
    Tula = 'Tula',
    Voronezh = 'Voronezh',
    Krasnodar = 'Krasnodar',
    Stavropol = 'Stavropol',
    NNovgorod = 'NNovgorod',
    Samara = 'Samara',
    Ufa = 'Ufa',
    Permian = 'Permian',
    Yekaterinburg = 'Yekaterinburg',
    NUrengoy = 'NUrengoy',
    Surgut = 'Surgut',
    Tomsk = 'Tomsk',
    Novosibirsk = 'Novosibirsk',
    Kemerovo = 'Kemerovo',
    Krasnoyarsk = 'Krasnoyarsk',
    Vladivostok = 'Vladivostok',
}

export enum BussinesTripRouteA {
    Kaliningrad_Krasnoyarsk = 'Kaliningrad_Krasnoyarsk',
    NUrengoy_Moscow = 'NUrengoy_Moscow',
    SPetersburg_Ufa = 'SPetersburg_Ufa',
    Yekaterinburg_Krasnodar = 'Yekaterinburg_Krasnodar',
    Voronezh_Surgut = 'Voronezh_Surgut',
    Surgut_SPetersburg = 'Surgut_SPetersburg',
    Ufa_Kaliningrad = 'Ufa_Kaliningrad',
    Moscow_Yekaterinburg = 'Moscow_Yekaterinburg',
    Krasnoyarsk_Krasnodar = 'Krasnoyarsk_Krasnodar',
    Ufa_Voronezh = 'Ufa_Voronezh',
}

export enum BussinesTripRouteB {
    Moscow_Vladivostok = 'Moscow_Vladivostok',
    Tula_Kemerovo = 'Tula_Kemerovo',
    Vladivostok_Tomsk = 'Vladivostok_Tomsk',
    Stavropol_Permian = 'Stavropol_Permian',
    Tomsk_Samara = 'Tomsk_Samara',
    Permian_Novosibirsk = 'Permian_Novosibirsk',
    Samara_Tula = 'Samara_Tula',
    NNovgorod_Stavropol = 'NNovgorod_Stavropol',
    Novosibirsk_NNovgorod = 'Novosibirsk_NNovgorod',
    Kemerovo_Moscow = 'Kemerovo_Moscow'
}

export enum BussinesTripRouteType {
    A = 'a',
    B = 'b'
}

@Singleton
export class BussinesTripModel {
    public routesCount: number = 3;
    public routeIndex: number = -1;

    public routes: Array<string> = new Array<string>();
    public routeType: BussinesTripRouteType = BussinesTripRouteType.A;

    public markers: Array<BussinesTripMarkerModel> = new Array<BussinesTripMarkerModel>();
    public markersAll: Array<BussinesTripMarkerModel> = new Array<BussinesTripMarkerModel>();
    public selectedMarkers: Array<BussinesTripMarkerModel> = new Array<BussinesTripMarkerModel>();

    public markerStrings: any = {
        Kaliningrad: 'Калинингад',
        SPetersburg: 'С-Петербург',
        Moscow: 'Москва',
        Tula: 'Тула',
        Voronezh: 'Воронеж',
        Krasnodar: 'Краснодар',
        Stavropol: 'Ставрополь',
        NNovgorod: 'Н.Новгород',
        Samara: 'Самара',
        Ufa: 'Уфа',
        Permian: 'Пермь',
        Yekaterinburg: 'Екатеринбург',
        NUrengoy: 'Новый Уренгой',
        Surgut: 'Сургут',
        Tomsk: 'Томск',
        Novosibirsk: 'Новосибирск',
        Kemerovo: 'Кемерово',
        Krasnoyarsk: 'Красноярск',
        Vladivostok: 'Владивосток',
    };

    constructor(
        @Inject private _$random: GameRandom,
        @Inject private _$modelEvents: ModelEvents,
    ) {
        Object.keys(BussinesTripCity).forEach(o => {
            this.markersAll.push(new BussinesTripMarkerModel(o));
        });
    }
}
